import { Language } from "@/models/language";

const state = {
  language: null as Language | null,
};

export type StateType = typeof state;
export default state;
